import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  // @ts-ignore
  @Input() user: User;

  consumerUrl: string = environment.consumerUrl;
  chartsUrl: string = environment.chartsUrl;
  mobileUrl: string = environment.mobileUrl;
  thirdPartyUrl: string = environment.thirdPartyUrl;
  yammerUrl: string = environment.yammerURl;
  
  constructor(
    public router: Router,
    public dialog: MatDialog, 
    private coreService: CoreService
  ) { }

  ngOnInit(): void {
  }

  openHelpDialog(): void {
    let dialogRef = this.dialog.open(HelpDialogComponent, {
      width: '900px', 
      height: '85vh', 
      maxHeight: '600px'
    })
  }

  async testTokenExpiration() {
    await this.coreService.simulateTokenExpiration();
  }

}
